<div class="flex flex-col min-h-screen">

    <div class="flex-1 py-4">
        <div class="w-full max-w-5xl mx-auto px-4">
            <router-outlet></router-outlet>
        </div>
    </div>

    <footer class="flex items-center justify-center gap-1 py-3 text-sm text-base-content/40">
        2022 - {{currentYear | date : 'yyyy'}} &copy;
        <a href="https://www.guideglare.com" class="hover:text-base-content/60 transition-colors no-underline" target="_blank">GuideGlare</a>
        by
        <a href="https://www.explicaire.com" target="_blank" class="flex items-center opacity-60 hover:opacity-80 transition-opacity">
            <img src="/assets/images/explicaire_dark.svg" style="display:inline;height:14px;width:auto" alt="Explicaire"/>
        </a>
    </footer>

</div>
